import GLightbox from 'glightbox';
import bus from '../util/eventBus';

const modal = () => {
  const lightbox = GLightbox({
    touchNavigation: true,
    autoplayVideos: true,
    loop: true,
    width: '1800px',
    moreLength: 0,
    height: 'auto',
    lightboxHTML: `<div id="glightbox-body" class="glightbox-container">
          <div class="gloader visible"></div>
          <div class="goverlay"></div>
          <div class="gcontainer">
            <div id="glightbox-slider" class="gslider">
            <div class="gbtn-nav gbtn-nav--hidden">
              <button class="gprev gbtn" tabindex="1" aria-label="Previous"><</button>
              <button class="gnext gbtn" tabindex="0" aria-label="Next"> > </button>
            </div>
          </div>
        </div>`,
    slideHTML: `<div class="gslide">
        <div class="gslide-inner-content">
          <div class="ginner-container">
            <div class="gslide-media"></div>
            <div class="gslide-description">
              <div class="gdesc-inner">
                <h4 class="gslide-title"></h4>
                <div class="gslide-desc"></div>
              </div>
            </div>
            <button class="gclose gbtn" tabindex="0" aria-label="Next">
              <svg data-modal-close>
                <use xlink:href="#icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="gbtn-nav">
            <button class="gprev gbtn" tabindex="1" aria-label="Previous">
              <svg>
                <use xlink:href="#icon-arrow-left"></use>
              </svg>
            </button>
            <button class="gnext gbtn" tabindex="0" aria-label="Next">
              <svg>
                <use xlink:href="#icon-arrow-right"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>`,
  });

  // eslint-disable-next-line no-unused-vars
  lightbox.on('slide_after_load', data => {
    const { trigger, slideNode } = data;
    const modalElm = document.querySelector('#glightbox-body');
    const skin = trigger.dataset.skin ?? null;
    if (skin && slideNode.classList.contains('current')) {
      modalElm.classList.add(skin);
    }
  });

  lightbox.on('open', () => {
    bus.emit('arca-modal-loaded', true);

    const prev = document.querySelectorAll('.gprev');
    const next = document.querySelectorAll('.gnext');
    const close = document.querySelectorAll('.gclose,.gclose svg');

    if (prev.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < prev.length; i++) {
        prev[i].addEventListener('click', () => {
          lightbox.prevSlide();
        });
      }
    }

    if (next.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < next.length; i++) {
        next[i].addEventListener('click', () => {
          lightbox.nextSlide();
        });
      }
    }

    if (close.length) {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < close.length; i++) {
        close[i].addEventListener('click', () => {
          lightbox.close();
        });
      }
    }
  });
  // eslint-disable-next-line no-unused-vars
  lightbox.on('slide_changed', ({ prev, current }) => {
    bus.emit('arca-modal-loaded', true);
  });
};

const modalRefresh = () => {
  document.addEventListener('facetwp-loaded', () => modal());
  document.addEventListener('facetwp-refresh', () => modal());
};

modal();
modalRefresh();
